import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "../common/GenericModal";
import PersonalScreenQrModal from "./personalScreenQrModal"
interface IParams {
  screen: IScreenStatus;
}

const PersonalScreenQrButton: React.FC<IParams> = ({ screen }) => {

  const [isModalOpen, setisModalOpen] = useState(false);
  const [t] = useTranslation(["browse_page"], translationHookOptions);




  return (
    <>
      <Button
        onClick={() => setisModalOpen(true)}
        className="screenQrButton mr-2"
      >
        <i className="fas fa-qrcode fa-4x screenQrIcon"></i>
        <h5 className="mb-0">{t("screens_personal_showqr")}</h5>
      </Button>
      
      <GenericModal
        modalClassname="personalScreenQrModal"
        modalBodyClassname="py-sm-1"
        isOpen={isModalOpen}
        toggle={() => setisModalOpen(!isModalOpen)}
        title={t("screens_personal_showqr_modal_title") + " - " + t("screens_personal_code_label") + " " + screen.code}
        size="lg"
        content={
          <>
           <PersonalScreenQrModal screen={screen}></PersonalScreenQrModal>
          </>
          }
          />

    </>
  );
};

export default observer(PersonalScreenQrButton);
